export default            
    {
        path:'/videoCourse',
        name:'视频课程',
        redirect:'/videoCourse/main',
        component:()=>import('../views/videoCourse/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/videoCourse/main',
                name:'视频课程主页',
                component:()=>import('../views/videoCourse/main.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/videoCourse/videoList',
                name:'视频课程列表',
                component:()=>import('../views/videoCourse/videoList.vue'),
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }